<template>
  <div class="i-keyword-details-summary">
    <div
      v-if="!!props.summary && showSummaryFirst"
      class="summary point"
    >
      <strong>Summary</strong>
      {{ props.summary }}
    </div>
    <div
      v-if="props.showKeys"
      class="keys"
    >
      <div
        v-for="key in Object.keys(props.data)"
        :key="key"
        class="key"
      >
        {{ key }}
      </div>
    </div>
    <div class="detailed">
      <div
        v-for="point in Object.keys(props.data)"
        :key="point"
        class="point"
      >
        <strong>{{ point }}:</strong> {{ props.data[point] }}
      </div>
    </div>
    <div
      v-if="!!props.summary && !showSummaryFirst"
      class="summary point"
    >
      <strong>Summary</strong>
      {{ props.summary }}
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  data: {
    type: Object as () => { [title: string]: string },
    required: true
  },
  summary: {
    type: String,
    default: ""
  },
  showKeys: {
    type: Boolean,
    default: true
  },
  showSummaryFirst: {
    type: Boolean,
    default: false
  }
})
</script>

<style scoped lang="scss">
.i-keyword-details-summary {
  color: $pickle-bluewood900;

  .keys {
    @include border-radius-md;

    border: 1px solid $zumthor100;

    @include grid($cols: 1fr, $rows: 1fr 1fr 1fr, $align-items: center);

    width: 100%;
    padding: 0;
    margin-top: 25px;

    @media screen and (min-width: $breakpoint-md) {
      @include grid($cols: 1fr 1fr 1fr, $rows: 1fr, $align-items: center);

      padding: 15px 0;
    }

    .key {
      @include text-md;

      font-weight: 600;
      padding: 15px 5px;
      text-align: center;

      @media screen and (min-width: $breakpoint-md) {
        padding: 5px;
      }

      &:not(:last-child) {
        border-bottom: 1px solid $zumthor100;

        @media screen and (min-width: $breakpoint-md) {
          border: unset;
          border-right: 1px solid $zumthor100;
        }
      }
    }
  }

  .detailed {
    @include flex(column, start, stretch, $gap: 28px);

    margin-top: 25px;
  }

  .point {
    @include text-md;

    font-weight: 500;
    color: $comet600;

    strong {
      color: $pickle-bluewood900;
    }
  }

  .summary {
    @include flex(column, start, stretch, $gap: 10px);

    padding: 20px;
    background-color: $azure-radiance100;

    @include border-radius-md;

    margin-top: 30px;
  }
}
</style>
